import { render, staticRenderFns } from "./smallModal.vue?vue&type=template&id=ba4fd404"
import script from "./smallModal.vue?vue&type=script&lang=js"
export * from "./smallModal.vue?vue&type=script&lang=js"
import style0 from "./smallModal.vue?vue&type=style&index=0&id=ba4fd404&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports